<template>
  <AlertSubscriptions v-if="userCanViewAlertSubs" :useClientLayout="true" />
  <AdminLayout
    v-else
    page="Alert Subscriptions Report"
    title="Alert Subscriptions Report"
  >
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import AlertSubscriptions from "../staffadmin/AlertSubscriptions.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

// Does user have permission to view alert subscriptions
var userCanViewAlertSubs = computed(() =>
  useUserStore().hasPermission(PermissionType.ViewAlertSubscriptions)
);
</script>
